import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { LldRecapComponent, MaApRecapComponent, MaLtRecapComponent, WedgeTableComponent } from '../../correction';
import { ApexTableComponent, LldTableComponent, MaApTableComponent, MaLtTableComponent } from '../../deformity';
import { BaseComponent } from '../../shared';


/**
 * Second left vertical bar.
 */
@Component({
	selector: 'drawer',
	templateUrl: './drawer.component.html',
	imports: [
		LldRecapComponent,
		LldTableComponent,
		MaApTableComponent,
		MaLtTableComponent,
		ApexTableComponent,
		MaApRecapComponent,
		MaLtRecapComponent,
		WedgeTableComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DrawerComponent extends BaseComponent implements OnInit, OnDestroy {

	isDeformityDrawerOpen = false;
	isCorrectionDrawerOpen = false;

	private _drawerClosureSub$?: Subscription;

	private _maApTable?: MaApTableComponent;
	@ViewChild(MaApTableComponent) set maApTable(table: MaApTableComponent) {
		setTimeout(() => {
			this._maApTable = table;
		}, 0);
	};

	private _maLtTable?: MaLtTableComponent;
	@ViewChild(MaLtTableComponent) set maLtTable(table: MaLtTableComponent) {
		setTimeout(() => {
			this._maLtTable = table;
		}, 0);
	};

	private _maApRecap?: MaApRecapComponent;
	@ViewChild(MaApRecapComponent) set maApRecap(table: MaApRecapComponent) {
		setTimeout(() => {
			this._maApRecap = table;
		}, 0);
	};

	private _maLtRecap?: MaLtRecapComponent;
	@ViewChild(MaLtRecapComponent) set maLtRecap(table: MaLtRecapComponent) {
		setTimeout(() => {
			this._maLtRecap = table;
		}, 0);
	};


	ngOnInit(): void {
		this._drawerClosureSub$ = this.canvasSrv.drawerClosure().subscribe(() => this.isDeformityDrawerOpen = false);
	}

	/**
	* Check if deformity measures are out of range.
	*/
	get isDeformityOutOfRange(): boolean {
		return !!this._maApTable?.isMeasureOutOfRange || !!this._maLtTable?.isMeasureOutOfRange;
	}

	/**
	* Check if correction drawer is visible.
	*/
	get isCorrectionDrawerVisible(): boolean {
		return !!this.stateType && (this.stateType === this.stateTypeEnum.EOC || this.stateType === this.stateTypeEnum.templating);
	}

	/**
	* Check if correction measures are out of range.
	*/
	get isCorrectionOutOfRange(): boolean {
		return !!this._maApRecap?.isMeasureOutOfRange || !!this._maLtRecap?.isMeasureOutOfRange;
	}


	ngOnDestroy(): void {
		this._drawerClosureSub$?.unsubscribe();
	}

}
